const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Action to save and fetch data
import { buyvotesPayment, fetchposts, fetchsinglepost } from '../../actions/front_actions';

//Import Designs
import {
    Typography,
    Grid2,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Link,
    Button,
    Backdrop,
    CircularProgress,
} from '@mui/material';
import copy from "copy-to-clipboard";
import VisibilityIcon from '@mui/icons-material/Visibility';
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from '@mui/icons-material/Share';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import ContestantTitle from './ContestantTitle.jsx';
import DisplayAuthorInfo from './DisplayAuthorInfo.jsx';
import ContestantDescription from './ContestantDescription.jsx';
import ContestantImage from './ContestantImage.jsx';
import VideoContestant from './VideoContestant.jsx';
import ContestantSocial from './ContestantSocial.jsx';
import VoteButton from './VoteButton.jsx';
import ContestantCustom from './ContestantCustom.jsx';
import ContestantGrid from './ContestantGrid.jsx';

let current_date = null;
class ContestantSingle extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '', opensocial: false, copied: false, author: '', butn_msg: null };
    }

    componentDidMount = () => {
        this.props.fetchsinglepost(this.props.SITE_URL, this.props.contestant_id);
    }

    getauthor = (author_id) => {
        this.setState({ author: author_id });
    }

    clearauthor = (author_id) => {
        this.setState({ author: '' });
    }

    shareSocial = () => {
        this.setState(prevState => ({
            opensocial: !prevState.opensocial
        }));
    }

    copyshareSocial = (value) => {
        this.setState(prevState => ({
            copied: !prevState.copied
        }));
        copy(value);
        document.execCommand("copy");
    }

    getVoteButtonText = (btnText) => {
        this.setState({ butn_msg: btnText });
    }

    render() {
        const { t, i18n } = this.props;

        const posts = this.props.post.post_single;
        current_date = new Date(this.props.post.current_date);
        const allprops = this.props;
        const { votes_button_bgcolor, votes_button_font_color } = this.props.settings.color;
        let show_desc = null;
        let single_title = allprops.settings.common.single_page_title;
        let contest_type = null;

        if (typeof allprops.custom_field !== "undefined") {
            allprops.custom_field.map(function (key, index) {
                if (key.system_name === 'contestant-desc') {
                    show_desc = key;
                }
            });
            if (show_desc)
                show_desc = show_desc.admin_view;
        }

        if (typeof allprops.short.allcatoption !== "undefined") {
            contest_type = this.props.short.contest_type;
        }

        let vote_count_showhide = null;
        if (typeof this.props.short.allcatoption !== "undefined") {
            if (this.props.short.allcatoption.style) {
                vote_count_showhide = this.props.short.allcatoption.style.vote_count_showhide;
            } else {
                vote_count_showhide = (typeof this.props.settings.style !== "undefined") ? this.props.settings.style.vote_count_showhide : 'on';
            }
        }

        if (typeof posts !== "undefined") {
            return (
                (<Grid2 container className="wpvc_showcontestant_container">
                    <Grid2 container size={12} direction="row" className="wpvc_show_style">

                        <Grid2 className="wpvc_show_style_row" size={12}>
                            <Card className="wpvc_card_row">
                                <VoteButton {...allprops} singlepost={posts} single_page="on" indexpost="null" view="single" currentdate={current_date} setButtonText={this.getVoteButtonText} wait={0} />
                                {single_title == 'on' &&
                                    <div className="wpvc_single_contestant_title" >
                                        <ContestantTitle {...allprops} singlepost={posts} view={this.props.view} changeauthor={this.getauthor} />
                                    </div>
                                }

                                {contest_type != null && (contest_type == "photo" || contest_type == "essay") &&
                                    <ContestantImage {...allprops} singlepost={posts} indexpost="null" view="single" currentdate={current_date} setButtonText={this.getVoteButtonText} butn_msg={this.state.butn_msg} />
                                }
                                {contest_type != null && (contest_type == "video" || contest_type == "music") &&
                                    <VideoContestant {...allprops} singlepost={posts} indexpost="null" view="single" currentdate={current_date} />
                                }

                                <CardContent className="wpvc_card_content_row">
                                    {single_title == 'off' &&
                                        <ContestantTitle {...allprops} singlepost={posts} view={this.props.view} changeauthor={this.getauthor} />
                                    }

                                    <DisplayAuthorInfo {...allprops} singlepost={posts} view={this.props.view} changeauthor={this.getauthor} />

                                    {
                                        show_desc != 'N' && show_desc != '' &&
                                        <ContestantDescription {...allprops} singlepost={posts} view="single" />
                                    }


                                    <ContestantCustom {...allprops} singlepost={posts} view="single" currentdate={current_date} />
                                </CardContent>

                                <CardActions style={{ padding: 0 }} className="wpvc_card_actions_row">
                                    <Grid2 className="wpvc_share_single_header" container style={{ justifyContent: 'space-between', background: votes_button_bgcolor, color: votes_button_font_color }}>
                                        <Grid2 style={{ padding: 16 }} >
                                            {
                                                vote_count_showhide === 'on' &&
                                                <Typography className="wpvc_card_actions_single">
                                                    <FavoriteIcon /><span>{posts.votes_count}</span>
                                                </Typography>
                                            }
                                            <Typography className="wpvc_card_actions_single">
                                                <VisibilityIcon /><span>{posts.votes_viewers}</span>
                                            </Typography>
                                        </Grid2>
                                        <Grid2 style={{ padding: 16 }} >
                                            <Link color='inherit' href={undefined} className="wpvc_share_social_single" onClick={this.shareSocial}>
                                                <span>{t("share_contestant")}</span><ShareIcon />
                                            </Link>
                                        </Grid2>

                                        {this.state.opensocial == true &&
                                            <Grid2 container size={12} direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                style={{ color: votes_button_font_color }}
                                                className="wpvc_single_social">
                                                <Grid2 className="wpvc_single_social_item" size={12}>
                                                    <ContestantSocial {...allprops} singlepost={posts} view={this.props.view} />
                                                </Grid2>
                                                <Grid2 className="wpvc_single_copy_link" size={12}>

                                                    {this.state.copied &&
                                                        <Typography className="wpvc_copied">{t("copied")}</Typography>
                                                    }
                                                    <Button
                                                        variant="contained"
                                                        className="wpvc_share_social_button"
                                                        color="primary"
                                                        startIcon={<FileCopyIcon />}
                                                        onClick={() => { this.copyshareSocial(posts.link) }}
                                                    >
                                                        {posts.link}
                                                    </Button>

                                                </Grid2>
                                            </Grid2>
                                        }

                                    </Grid2>

                                </CardActions>

                            </Card>
                        </Grid2>

                    </Grid2>
                    {this.state.author != '' &&
                        <ContestantGrid {...allprops}
                            view="grid"
                            short={allprops.short}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            search=''
                            author_id={this.state.author}
                            authorfunc={this.clearauthor}
                        />
                    }
                </Grid2>)
            );
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, { buyvotesPayment, fetchsinglepost, fetchposts })(withTranslation("translations")(ContestantSingle));
